export default __webpack_public_path__ + "static/media/west_24dp.77f97c6f.svg";